import IconButton from '@mui/material/IconButton';
import Input from '@mui/material/Input';
import InputAdornment from '@mui/material/InputAdornment';
import FormControl from '@mui/material/FormControl';
import SearchIcon from '@mui/icons-material/Search';
import propsType from 'prop-types';
import { Box } from '@mui/material';

const Search = (props) => {
   const { onSearch } = props;

   const handleSearchChange = (event) => {
      const query = event.target.value;
      onSearch(query);
   };

   return (
      <Box
         sx={{
            margin: '20px 0',
            border: '1px solid #00000021',
            borderRadius: '10px',
            padding: '5px 10px',
            display: 'flex',
            alignItems: 'center',
            backgroundColor: '#fff',
         }}
      >
         <IconButton sx={{ padding: '3px 5px' }}>
            <SearchIcon />
         </IconButton>
         <Input
            id="standard-adornment-password"
            placeholder={
               props?.customPlaceHolder ? props.customPlaceHolder : 'Search by Name or Account'
            }
            type="text"
            onChange={handleSearchChange}
            disableUnderline
            sx={{
               fontSize: 14,
               fontWeight: 500,
               color: '#363434',
            }}
         />
      </Box>
   );
};

Search.propTypes = {
   onSearch: propsType.func,
};

export default Search;
